module.exports = __webpack_public_path__ + "static/img/img1.5dde328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/img1.jpg
// module id = RMoE
// module chunks = 0